import * as Msal from "msal";
import Cookies from 'js-cookie';

export default class MsalConnect {
  constructor() {
    this.loginRequest = {
      scopes: ["openid", "profile", "User.Read"],
    };

    this.msalConfig = {
      auth: {
        clientId: process.env.MSAL_CLIENT_ID, // this is the real id
        authority: "https://login.microsoftonline.com/57fe7bb5-e382-4498-88fe-5c50d256f735",
        redirectUri: window.location.origin,
      },
      cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
      }
    };  

    // Add here the endpoints for MS Graph API services you would like to use.
    this.graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
      graphMailEndpoint: "https://graph.microsoft.cocallMSGraphm/v1.0/me/messages"
    };

    this.loginRequest = {
      scopes: ["openid", "profile", "User.Read"],
    };
  }

  login = () => {

    if(!this.myMSALObj) {
      this.myMSALObj = new Msal.UserAgentApplication(this.msalConfig);
    }

    return this.myMSALObj.loginPopup(this.loginRequest).then(loginResponse => {
      console.log('id_token acquired at: ' + new Date().toString());
      console.log(loginResponse);
      Cookies.set('uniqueId', loginResponse.uniqueId || true, { expires: 3 })
      return(loginResponse);
      
    }).catch(error => {
      console.log(error);
      return(error);
    });
  }

  signOut = e => {
    if(this.myMSALObj) {
      this.myMSALObj.logout();
    }    
  }
}